/** Components for `./tenancy-names`, split out so that module can stay a plain `.ts`. */
import * as React from "react";
import { type NameOverridesValue, NameOverridesContext } from "./tenancy-names";

export function NameOverridesProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const [overrides, setOverrides] = React.useState<Record<string, string>>({});

  const setName = React.useCallback((id: string | null | undefined, name: string) => {
    const trimmed = name.trim();
    if (!id || !trimmed) return;
    setOverrides((prev) => (prev[id] === trimmed ? prev : { ...prev, [id]: trimmed }));
  }, []);

  const value = React.useMemo<NameOverridesValue>(() => ({ overrides, setName }), [overrides, setName]);
  return <NameOverridesContext.Provider value={value}>{children}</NameOverridesContext.Provider>;
}
